export default "__VITE_ASSET__vCPb$7mA__"